<template>
  <div class="">
    <b-table sticky-header :items="items" style="height: 150px" :striped="true" :small="true"></b-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          Rank: "1",
          Nama: "Ivan",
          Nilai: "97",
        },
        {
          Rank: "2",
          Nama: "Marsel",
          Nilai: "94",
        },
        {
          Rank: "3",
          Nama: "Budi",
          Nilai: "70",
        },
                {
          Rank: "3",
          Nama: "Budi",
          Nilai: "70",
        },
                {
          Rank: "3",
          Nama: "Budi",
          Nilai: "70",
        },
                {
          Rank: "3",
          Nama: "Budi",
          Nilai: "70",
        },
                {
          Rank: "3",
          Nama: "Budi",
          Nilai: "70",
        },
                {
          Rank: "3",
          Nama: "Budi",
          Nilai: "70",
        },
      ],
    };
  },
};
</script>

